import React from 'react'
import * as st from '~/assets/styl/DVert.module.styl'
import { useLanguage } from '~/hooks'

export default function DVert() {
  const { t } = useLanguage()

  return (
    <section className={st.core} id="DVert">
      <h2>{t('DVert.title')}</h2>
    </section>
  )
}
